<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title>{{ name }}</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Name"
          v-model="name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ value }}</code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  components: { BasicDialog },
  name: "payment-method-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "New Payment Method",
    };
  },

  computed: {
    isValid() {
      return this.name != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.name = val.name ? val.name : "New Payment Method";
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value ? this.value.id : null,
        name: this.name,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/payment-methods/PaymentMethodEditDialog.vue